




























import Multiselect from 'vue-multiselect';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    Multiselect,
  },
})
export default class VSelect extends Vue {
  @Prop()
  private value!: any;

  @Prop()
  private allowEmpty!: boolean;

  @Prop()
  private hideSelected!: boolean;

  @Prop()
  private closeOnSelect!: boolean;

  @Prop()
  private preselectFirst!: boolean;

  @Prop()
  private showNoResults!: boolean;

  @Prop()
  private multiple!: boolean;

  @Prop()
  private loading!: boolean;

  @Prop()
  private trackBy!: string;

  @Prop()
  private label!: string;

  @Prop()
  private noOptions!: string;

  @Prop()
  private noResult!: string;

  @Prop()
  private placeholder!: string;

  @Prop()
  private options!: any;

  @Prop({ default: false })
  private internalSearch!: any;

  private timer: any = null;

  private searchChange(value: any) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.$emit('search-change', value), 800);
  }

  private updateValue(value: any) {
    this.$emit('input', value);
  }

  private select(value: any) {
    this.$emit('select', value);
  }

  private remove(value: any) {
    this.$emit('remove', value);
  }

  private open() {
    this.$emit('open');
  }

  get valueOptions() {
    if (this.options) {
      return this.options;
    }
    return [];
  }
}
